import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Box, Button, Typography } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useTranslation } from 'react-i18next';
import { InfoIcon } from '../CustomIcons';
import DOMPurify from 'dompurify';
const useStyles = makeStyles(theme => ({
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  header: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    maxWidth: '330px',
    marginTop: theme.spacing(2)
  },
  body: {
    textAlign: 'center',
    padding: ' 0 16px',
    color: '#455775'
  },
  button: {
    borderRadius: 32
  },
  closeButtonWrapper: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    color: theme.palette.colorPalette[1],

    '&:hover': {
      cursor: 'pointer'
    }
  },
  buttonsWrapper: {
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2)
  }
}));

const PromptModal = ({
  onConfirm,
  closeModal,
  icon = <InfoIcon />,
  content: ModalCustomContent,
  confirmLabel = null,
  header = null,
  description = null
} = {}) => {
  const classes = useStyles();
  const { t } = useTranslation(['common']);

  const handleAccept = () => {
    onConfirm();

    closeModal();
  };

  return (
    <>
      <div className={classes.closeButtonWrapper} onClick={closeModal}>
        <HighlightOffIcon />
      </div>
      {header && (
        <Typography className={classes.header} variant="h4" textAlign="left">
          {header}
        </Typography>
      )}
      <div className={classes.iconWrapper}>{icon}</div>
      {ModalCustomContent && (
        <div>
          <ModalCustomContent />
        </div>
      )}
      {description && (
        <Box justifyContent="center" display="flex" maxWidth="330px" mt={2} mb={1}>
          <Typography
            className={classes.description}
            textAlign="left"
            fontSize={16}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
          />
        </Box>
      )}
      <div className={classes.buttonsWrapper}>
        <Button onClick={closeModal} className={classes.button} color="primary" variant="outlined">
          {t('cancel')}
        </Button>
        <Button onClick={handleAccept} className={classes.button} color="primary" variant="contained">
          {confirmLabel || t('accept')}
        </Button>
      </div>
    </>
  );
};

PromptModal.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  onConfirm: PropTypes.func,
  closeModal: PropTypes.func,
  content: PropTypes.func,
  confirmLabel: PropTypes.string
};

export default PromptModal;
